// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"804":"f729a443","1313":"c088f5df","3332":"dd93b8b9","5604":"7735f3e7","6323":"f174c8ab","8116":"bb2b897b"}[chunkId] + ".chunk.css";
};